export default { sha: '94890a66721017a1ffce2e9d3ce156ba3933ee8c', buildNumber: 'undefined' }
